import { render, staticRenderFns } from "./KaiEntityForm.vue?vue&type=template&id=58249fda&"
import script from "./KaiEntityForm.vue?vue&type=script&lang=ts&"
export * from "./KaiEntityForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports